import React from "react";
import { useCreateNewUserConversationMutation } 
  from "@/features/userConversations/userConversationsApiSlice";

import { buildUserConversationPayload } 
    from "@/features/userConversations/buildUserConversationPayload";

const EtDeleteUserConversationLandingComp = ({
  conversationMaster,
  onClose = () => {},
  refetchUserConversations = () => {},
}) => {

  // First Created -  24 Jan 2026
  // Author -  Atul Pandey
  // Purpose -  Delete a single UserConversation note (Contact | All)
  //          via payload-driven backend contract

  // ------------------------------------------------------------------
  // 1️⃣ Extract authoritative references
  // ------------------------------------------------------------------
  const {
    sourceConversation,
    conversationText,
    contactId,
    trailId,
    sessionId,
    selectedFocus,
    connectedEntities = [],

    userId,
    userOrgId,
    
    userMagicMomentId,
    
  } = conversationMaster || {};

  const {
    sourceNoteType,           // 'Contact' | 'All'
    sourceNoteId,
    userConversationId,       // populated
  } = sourceConversation || {};

  const weekStarting = userConversationId?.weekStarting;

  // ------------------------------------------------------------------
  // 2️⃣ Safeguards
  // ------------------------------------------------------------------
  const isMagicMoment = !!userMagicMomentId;

  const [deleteConversation] =
    useCreateNewUserConversationMutation();

  // ------------------------------------------------------------------
  // 3️⃣ Handle Delete
  // ------------------------------------------------------------------
  
  const handleDelete = async () => {

     if (isMagicMoment) {
      alert(
        "This conversation has been marked as a Magic Moment and cannot be deleted."
      );
      return;
    }


      try {
        const payload = buildUserConversationPayload({
          userId,
          userOrgId,
          weekStarting,
          noteType: sourceNoteType,
          note: {
            _id: sourceNoteId,
            delete: true,
          },
          context: {
            trailId,
            sessionId,
            selectedFocus,
            connectedEntities,
          },
        });
  
        await deleteConversation(payload).unwrap();
  
        refetchUserConversations();
        onClose();
      } catch (err) {
        console.error("Failed to delete conversation note:", err);
        alert("Failed to delete conversation");
      }
    };

  // ------------------------------------------------------------------
  // 4️⃣ Guards
  // ------------------------------------------------------------------
  if (!conversationMaster) {
    return <div>No conversation selected</div>;
  }

  // Create an object for setting inner HTML
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent }
  }

  // ------------------------------------------------------------------
  // 5️⃣ UI
  // ------------------------------------------------------------------
  return (
    <div className="p-4 bg-white rounded">

      <h2 className="text-lg font-bold text-gray-800 mb-3">
        Delete Conversation
      </h2>

      <p className="text-sm text-gray-600 mb-4">
        Are you sure you want to delete this conversation?
      </p>

      <p className="mb-4 text-sm">
        <span className="text-red-600">
          Please remember, this action cannot be undone.
        </span>{" "}
        If you wish to proceed click{" "}
        <span className="font-bold text-red-600">"Yes"</span>, else click{" "}
        <span className="font-bold">"No"</span> to go back.
      </p>

      {/* Preview */}
      <div className="bg-gray-50 border p-3 rounded text-sm text-gray-700 mb-4" dangerouslySetInnerHTML={createMarkup(conversationText?.slice(0, 180))}>
        {/* {conversationText?.slice(0, 180) || "No content available"} */}
      </div>

      {isMagicMoment && (
        <p className="text-red-600 text-sm mb-4">
          ⚠️ This conversation has been marked as a Magic Moment and cannot be deleted.
        </p>
      )}

      <div className="flex space-x-3 mt-4">
        <button
          className="w-24 bg-gradient-to-r from-red-900 to-orange-600 hover:from-red-600 hover:to-red-700 text-white font-bold py-2 px-4 rounded-full"
          disabled={isMagicMoment}
          onClick={handleDelete}
        >
          Yes
        </button>

        <button
          className="w-24 bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded-full"
          onClick={onClose}
        >
          No
        </button>
      </div>
    </div>
  );
};

export default EtDeleteUserConversationLandingComp;